import { useApiDataService } from './use-api-data-service';
import { TaskService } from 'services/task-service';

export const useTaskService = () => useApiDataService<TaskService>(TaskService);
export default useTaskService;
